import { TimelineTicket } from './Homes'
import { ReservationsListRow } from './Reservation'

export type UserRole = `${UserRoles}`

export enum UserRoles {
  ADMIN = 'admin',
  APPLICANT = 'applicant',
  CORPORATE_COORDINATOR = 'professional_housing_coordinator',
  DIRECT_PARTNER = 'direct_partner',
  MEMBER = 'member',
  READ_ONLY_ADMIN = 'read_only_admin',
  SUPER_ADMIN = 'super_admin',
}

export enum APP_TYPE {
  COMMUNICATIONS = 'communications',
  SALES = 'sales',
  SETTINGS = 'settings',
  SUPPORT = 'support',
}

export interface UserListRow {
  email: string
  fullName?: string
  id: number
  role: number
}

export interface MemberListRow extends UserListRow {
  phone?: string
  roleName: string
}

export interface MemberDetail extends UserListRow {
  active: boolean
  appeasements?: Appeasement[]
  dateOfBirth?: string
  notes?: string
  phone: string
  reservations?: ReservationsListRow[]
  stayCommitments?: StayCommitment[]
  tickets?: TimelineTicket[]
}

export interface StayCommitment {
  cancelledAt?: string
  committedNights?: number
  createdAt: string
  earlyTerminationFeeType?: string
  earlyTerminationFeeWaivedAt?: string
  fulfilledAt?: string
}
export interface Appeasement {
  amount?: string
  category: string
  createdAt: string
  motivation?: string
  reason?: string
  status?: string
  team?: string
}
